
import { createReducer, on } from '@ngrx/store';
import { switchRegion, swtichTab } from '../store/region.action';


export interface RegionState {
  Country: string;
  tab: string
}

export interface TabState {
  tab: string;
}

export const initialState: RegionState = {
  Country: '',
  tab: '',
};


export const regionReducer = createReducer(
  initialState,

  on(switchRegion, (state, action) => ({
    ...state,
    Country: action.country,
  })),

  on (swtichTab, (state, action) => ({
    ...state,
    tab: action.tab
  }))
);
